module.exports = __webpack_public_path__ + "static/media/manuca-logo.76dd1cd4.png";